module.exports = __webpack_public_path__ + "static/media/plane.21caefcb.svg";